import { clsx } from 'clsx'
import { IconName } from 'icon/types'
import { CSSProperties, MouseEvent } from 'react'
import { omit } from 'util/object'
import css from './Icon.module.scss'

type Props = {
  name: IconName
  size?: number
  title?: string
  fill?: boolean
  primary?: boolean
  secondary?: boolean
  tertiary?: boolean
  error?: boolean
  success?: boolean
  className?: string
  style?: CSSProperties
  onClick?(event: MouseEvent): void
  onMouseDown?(event: MouseEvent): void
  y?: number
}

/**
 * Preview with search - https://fonts.google.com/icons
 */
export function Icon(props: Props) {
  const {
    name, size, title, fill, primary, secondary, tertiary,
    error, success, onClick, onMouseDown, y,
  } = props

  const variant = error ? css.error : success ? css.success : primary ? css.primary :
    secondary ? css.secondary : tertiary ? css.tertiary : undefined
  const className = clsx(props.className, 'material-symbols-outlined', css.icon, fill && css.fill, variant)
  const style = omit<CSSProperties>({ ...props.style, fontSize: size, marginTop: y })

  return <span className={className} title={title} style={style} onClick={onClick} onMouseDown={onMouseDown}>
    {name}
  </span>
}
